// extracted by mini-css-extract-plugin
export default {"itemName":"ListVariationsItem_itemName__RpVWR","customLabel":"ListVariationsItem_customLabel__LZYkC","errorText":"ListVariationsItem_errorText__NaKVl"};